import { __ } from '@wordpress/i18n';
import Astra_Admin_Icons from '@Common/block-icons';
import { getAction, triggerAction } from '@Utils/extensions';

const StarterTemplates = () => {

	if ( ! astra_admin.show_plugins ) {
		return;
	}

	if ( astra_admin.starter_templates_data.is_available ) {
		window.open(
			astra_admin.starter_templates_data.redirection,
			'_self'
		);
		return;
	}

	const handlePluginActionTrigger = ( e ) => triggerAction( e );

	const getTitle = ( status ) => {
		if (status === "activated") {
			return __( 'Activated', 'astra' );
		} else if (status === "installed") {
			return __( 'Activate', 'astra' );
		} else {
			return __( 'Install & Activate', 'astra' );
		}
	}

	const onLearnMoreGuideClick = () => {
		window.open(
			'https://wpastra.com/website-templates/?utm_source=dashboard&utm_medium=free-theme&utm_campaign=starter-templates',
			'_blank'
		);
	};

	return (
		<main className="relative tablet:my-16">
			<div className="w-full blur-sm opacity-40">
				{ Astra_Admin_Icons['starter-canvas'] }
			</div>

			{ /* Model Component section */ }
			<div>
				<div className="max-w-[39rem] h-max bg-white m-auto shadow-overlay-modal text-center rounded-lg p-8 absolute inset-3 top-[150%] sm:top-0 sm:inset-0">
					<div>
						<div className="mx-auto flex items-center justify-center">
							<img src={ astra_admin.starter_templates_data.icon_path } width="40px" height="40px" />
						</div>
						<div className="mt-3 text-center sm:mt-6">
							<h4
								className="text-2xl font-semibold leading-7 text-slate-800"
								id="modal-title"
							>
								{ astra_admin.starter_templates_data.title }
							</h4>
							<div className="mt-2">
								<p className="text-sm text-slate-500">
									{ __( 'Create professional designed pixel perfect websites in minutes. Get access to 280+ pre-made full website templates for your favorite page builder.', 'astra' ) }
								</p>
							</div>
						</div>
					</div>
					<div className="text-center mt-5 sm:mt-6">
						<button
							data-type="button"
							className="w-auto inline-flex items-center justify-center rounded-md border border-transparent bg-astra px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-astra-hover focus:outline-none focus:ring-2 focus:ring-astra-hover focus:ring-offset-2 sm:text-sm"
							data-slug={astra_admin.starter_templates_data.slug}
							data-init={astra_admin.starter_templates_data.path}
							data-redirection={astra_admin.starter_templates_data.redirection}
							data-action={getAction(astra_admin.starter_templates_data.status)}
							onClick={ handlePluginActionTrigger }
						>
							{ getTitle(astra_admin.starter_templates_data.status) }
						</button>
						<div>
							<button
								className="w-auto justify-center mt-4 text-astra"
								onClick={onLearnMoreGuideClick}
							>
							{ __( 'Learn More', 'astra' ) }
							</button>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
};

export default StarterTemplates;
